import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ConnectivityActions = createActionGroup({
  source: 'CONNECTIVITY',
  events: {
    'Reset to Initial state': emptyProps(),
    'Register user activity': emptyProps(),
    'Show inactivity modal': props<{ secondsLeft: number }>(),
    'Set is inactive': props<{ isInactive: boolean }>(),
    'Set inactivity time': props<{ inactivityTime: number }>(),
  },
});
